import React from "react";
import { ActivityIndicator, View } from "react-native";
import colors from "@constants/color";

const CoverLoader = () => {
  return (
    <View
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ActivityIndicator size="large" color={colors.primary} />
    </View>
  );
};

export default CoverLoader;
